import { AxiosSurveyConfiguration } from "./AxiosConfig";
import * as Constant from "./constants";

/* 
  Purpose:    Used to get survey form details by formKey
  Created By: Vinit kumar 
*/
export const getSurveyForm = (formKey) => {
  const axiosInstance = AxiosSurveyConfiguration();
  let bodyFormData = new FormData();
  bodyFormData.append("formkey", formKey);
  return axiosInstance
    .post("v1/survey_form/", bodyFormData)
    .then((response) => {
      let results = response.data.data;
      if (results) {
        const filter1 = results[0].form_json.replace(/"true"/g, "true"); // replace true
        const filter2 = filter1.replace(/"false"/g, "false"); // replace false
        const finalJson = filter2.replace(/"null"/g, "null"); // replace false

        return {
          status: "success",
          getSurveyName: results[0].survey_name,
          getParticipantID: results[0].participant_id,
          getSurveyID: results[0].survey_id,
          getConsent: results[0].consent_statement,
          getParticipantQualifications:
            results[0].participant_qualification_json,
          getParticipantLastAction: results[0].participant_action,
          getParticipantQualificationStatus:
            results[0].participant_qualification,
          getFormJson: finalJson,
          getSurveyStatus: results[0].status,
          getStatusType: results[0].surveyStatus,
          getCompanyLogo: results[0].manufacturer__company_logo,
          getDeviceLogo: results[0].device__device_image,
          getAttemptedStatus: results[0].attempted_status,
        };
      } else {
        return {
          status: "failure",
          message: "Result not found",
        };
      }
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose: common function to submit the table records
  Created By: Vinit Kumar 
*/
export const submitSurveyDetails = (bodyFormData) => {
  const axiosInstance = AxiosSurveyConfiguration();
  const url = "v1/survey_submission/";
  return axiosInstance
    .post(url, bodyFormData)
    .then((response) => {
      return {
        status: response.data.status,
        message: response.data.message,
        extra_data: response.data.extra_data,
      };
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose:Update Survey Participant Responses Status
  Created By: Dinesh Kumar 
*/
export const updateSurveyParticipantResponsesStatus = (bodyFormData) => {
  const axiosInstance = AxiosSurveyConfiguration();
  let url = "v1/update_survey_participant_responses_status/";
  return axiosInstance
    .post(url, bodyFormData)
    .then((response) => {
      return {
        status: response.data.status,
        message: response.data.message,
      };
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};
